import React, { useEffect, useState } from "react";
import { Group, Input, DateInput, Select } from "@peracto/peracto-ui";
import { GET_MANY, useClient } from "@peracto/client";

export const WarrantyFormContent = () => {
    const { client } = useClient();

    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchCountries = async () => {
        try {
            const { data: countryData } = await client(GET_MANY, "countries", {
                id: "countries",
            });

            if (countryData?.length > 0 && Array.isArray(countryData)) {
                setCountries(countryData);
            }

            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCountries();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) {
        return (
            <div className="card">
                <div className="card-body">Loading...</div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <Group name="Customer" id="customer">
                <Input
                    label="First Name"
                    required
                    name="firstName"
                    testId="warranty-first-name"
                />
                <Input
                    label="Last Name"
                    required
                    name="lastName"
                    testId="warranty-last-name"
                />
                <Input
                    label="Email"
                    required
                    name="email"
                    type="email"
                    testId="warranty-email"
                />

                <Select
                    name={`countryCode`}
                    label="Country"
                    options={countries.map((country) => ({
                        label: `${country.label} (${country.iso3})`,
                        value: country.iso3,
                    }))}
                    placeholder="Select a country"
                />
            </Group>

            <Group name="Purchase" id="purchase">
                <Input
                    label="Place of Purchase"
                    name="placeOfPurchase"
                    testId="warranty-place-of-purchase"
                    readOnly
                    disabled
                />
                <DateInput
                    label="Date of Purchase"
                    name="dateOfPurchase"
                    testId="warranty-date-of-purchase"
                    readOnly
                />
            </Group>

            <Group name="Product" id="product">
                <Input
                    label="Product Name & Model"
                    name="productNameAndModel"
                    testId="warranty-product-name-and-model"
                    readOnly
                    disabled
                />
                <Input
                    label="Serial Number"
                    name="serialNumber"
                    testId="warranty-serial-number"
                />
                <Input
                    label="Product Accessories"
                    name="productAccessories"
                    testId="warranty-product-accessories"
                    readOnly
                    disabled
                />
            </Group>

            <Group name="Installation" id="installation">
                <Input
                    label="Installed By"
                    name="installedBy"
                    testId="warranty-installed-by"
                    readOnly
                    disabled
                />
                <Input
                    label="Installer Name"
                    name="installerName"
                    testId="warranty-installer-name"
                    readOnly
                    disabled
                />
            </Group>
        </React.Fragment>
    );
};
